require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;



//////////////////
// WEBPACK FOOTER
// /var/www/beauty-shop.ru/~/core-js/fn/regexp/escape.js
// module id = 989
// module chunks = 32